"use client";
import styles from "@styles/newsletter.module.css";
import book from "@images/book.png";
import hat from "@images/hat.png";
import student from "@images/student.png";
import building from "@images/building.png";
import Image from "next/image";
import { useForm, SubmitHandler } from "react-hook-form";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export function Newsletter() {
  const [message, setMessage] = useState<string>("");
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [status, setStatus] = useState<number | null>(null);

  type FormData = {
    email: string
  }

  const form = useForm<FormData>();
  const { register, handleSubmit, reset, formState } = form;
  const { isDirty, isSubmitSuccessful, isSubmitting, errors } = formState;

  const submitForm: SubmitHandler<FormData> = async (data) => {
    setButtonDisabled(true);
    try {
      const response = await fetch("/api/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const resData = await response.json();
      if (resData.status >= 400) {
        setStatus(resData.status);
        setMessage("Error joining the newsletter!");
        setTimeout(() => {
          setMessage("");
          setButtonDisabled(false);
        }, 2000);
      }
      return resData;
    } catch (error: any) {
      console.error(error);
      toast.error(`${error.data.error_message}`)
      setMessage("Internal Server Error! Please try again.");
      setStatus(500);
      setTimeout(() => {
        setMessage("");
        setButtonDisabled(false);
      }, 2000);
    }
  };

  useEffect(() => {
    if (isSubmitting) {
      setButtonDisabled(true);
    }
    if (isSubmitSuccessful) {
      setStatus(200);
      reset();
      setMessage("You have successfully subscribed to our newsletter.");
      setTimeout(() => {
        setMessage("");
        setButtonDisabled(false);
      }, 3000);
    }
  }, [isSubmitting, isSubmitSuccessful, reset]);

  return (
    <div className={styles.newsletter_container}>
      <div className={styles.newsletter_left}>
        <div className={styles.newsletter_item}>
          <Image src={hat} className={styles.img1} alt="" />
          90%{" "}
          <span>
            Graduation <br /> employable
          </span>
        </div>
        <div className={styles.newsletter_item}>
          <Image src={book} className={styles.img2} alt="" />
          15 <span> majors</span>
        </div>
        <div className={styles.newsletter_item}>
          <Image src={building} className={styles.img3} alt="" />
          68 <span>class rooms</span>
        </div>
        <div className={styles.newsletter_item}>
          <Image src={student} className={styles.img4} alt="" />
          3k <span>students</span>
        </div>
      </div>
      <div className={styles.newsletter_right}>
        <div className={styles.newsletter_right_inner}>
          <h3>Subscribe to our newsletter</h3>
          <form onSubmit={handleSubmit(submitForm)}>
            <div className={styles.subscribe_input}>
              <input
                {...register("email", {
                  required: "Please enter email!",
                  pattern: {
                    value:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: "Please enter a valid email!",
                  },
                  validate: {
                    notThisEmail: (fieldValue) => {
                      return (
                        fieldValue != "admin@example.com" ||
                        "Please enter a different email"
                      );
                    },
                    notBadEmail: (fieldValue) => {
                      return (
                        !fieldValue.endsWith("@example.com") ||
                        "Please enter a different email"
                      );
                    },
                  },
                })}
                type="email"
                autoComplete="email"
                aria-label="Your email address"
                aria-invalid={!!errors.email}
                placeholder="Your email"
                id="email"
              />
              <button className={styles.desktop} disabled={buttonDisabled}>
                SUBMIT
              </button>
              {message !== "" ? (
                <p
                  role="status"
                  style={{ color: status === 200 ? "white" : "#FFFF00" }}
                  className={styles.mobile}
                >
                  {message}
                </p>
              ) : null}
              {errors.email ? (
                <p role="alert" style={{ color: "#FFFF00" }} className={styles.mobile}>
                  {errors.email?.message}
                </p>
              ) : null}
            </div>
            {message !== "" ? (
              <p
                role="status"
                style={{
                  color: status === 200 ? "white" : "#FFFF00",
                  marginTop: "5px",
                }}
                className={styles.desktop}
              >
                {message}
              </p>
            ) : null}
            {errors.email ? (
              <p
                role="alert"
                style={{ marginTop: "5px", color: "#FFFF00" }}
                className={styles.desktop}
              >
                {errors.email?.message}
              </p>
            ) : null}
            <button className={styles.mobile} disabled={buttonDisabled}>
              SUBMIT
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}


